'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFilter9Plus = function MdFilter9Plus(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 15v-10h-23.4v23.4h23.4v-10h-3.4v3.2h-3.2v-3.2h-3.4v-3.4h3.4v-3.4h3.2v3.4h3.4z m0-13.4q1.3 0 2.3 1.1t1.1 2.3v23.4q0 1.3-1.1 2.3t-2.3 0.9h-23.4q-1.3 0-2.3-0.9t-0.9-2.3v-23.4q0-1.3 0.9-2.3t2.3-1.1h23.4z m-16.6 13.4h1.6v-1.6h-1.6v1.6z m5 5q0 1.4-1.1 2.4t-2.3 1h-5v-3.4h5v-1.6h-1.6q-1.4 0-2.4-1t-1-2.4v-1.6q0-1.4 1-2.4t2.4-1h1.6q1.3 0 2.3 1t1.1 2.4v6.6z m-18.4-11.6v26.6h26.6v3.4h-26.6q-1.3 0-2.3-1.1t-1.1-2.3v-26.6h3.4z' })
        )
    );
};

exports.default = MdFilter9Plus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/filter-9-plus.js
// module id = 729
// module chunks = 0